export const AddDataSourceModalCustomStyles = {
  content: {
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 'fit-content',
    minWidth: '50%',
    maxWidth: '70%',
    height: 'fit-content',
    maxHeight: '50rem',
  },
  overlay: {
    background: 'rgba(71,84,93,0.8)',
    zIndex: 999,
  },
};
